import { Component } from '@theme/component';
class HeaderMenuContent extends Component {
    /**
     * @type {string | null}
     */
    #menuListId;

    connectedCallback() {
        super.connectedCallback();
        this.#menuListId = this.getAttribute('data-menu-list-id');
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    /*initTab = () => {
        console.log('initTab');
        const tabButtons = this.getTabButtons();
        if (tabButtons && tabButtons.length > 0) {
            const firstTabId = tabButtons[0]?.getAttribute('data-tab');
            console.log('firstTabId', firstTabId);
            if (firstTabId) {
                this.showTab(firstTabId);
            }
        }
    };*/

    /**
     * Show tab by id or event
     * @param {any} event - tab id
     */
    handleTabClick(event) {
        if (!event.target) return;
        const tabId = event.target.dataset.tab;
        this.showTab(tabId);
        this.resizeHeight();
    }

    /**
     * Show tab by id or event
     * @param {string} tabId - tab id
     */
    showTab(tabId) {
        if (!tabId) return;
        // Update tab button active state
        const tabButtons = this.getTabButtons();
        tabButtons.forEach((btn) => {
            btn.classList.toggle('active', btn.getAttribute('data-tab') === tabId);
        });

        // Show/hide tab contents
        const tabContents = this.getTabContents();

        tabContents.forEach((el) => {
            el.classList.remove('block', 'hidden');
            if (el.getAttribute('data-tab') === tabId) {
                el.classList.add('block');
            } else {
                el.classList.add('hidden');
            }
        });
    }
    /**
     * Show tab by id or event
     * @param {any} event - tab id
     */
    openCountrySelector(event) {
        let context = this;
        if (event && event.target) {
            context = event.target.closest('header-menu-content') || this;
        }
        const parentreference = event.target.dataset.parentreference;
        const countrySelector = context.querySelector(
            '#country-selector-container-' + parentreference
        );
        const menuContent = context.querySelector('#header-menu-content-tab-' + parentreference);
        if (countrySelector) {
            countrySelector.classList.remove('hidden');
            menuContent?.classList.add('hidden');
            this.resizeHeight();
        }
    }

    getTabButtons() {
        return this.querySelectorAll('.tab-btn');
    }
    getTabContents() {
        return this.querySelectorAll('[class^="tab-content"]');
    }

    /*The header menu content needs to inform the header menu about the height of the submenu*/
    resizeHeight() {
        const submenu = findSubmenu(this);
        if (!submenu) return;
        const submenuHeight = submenu.offsetHeight;
        const headerMenu = document.querySelector('header-menu');
        if (headerMenu instanceof HTMLElement) {
            headerMenu.style.setProperty('--submenu-height', `${submenuHeight}px`);
        }
    }
}

if (!customElements.get('header-menu-content')) {
    customElements.define('header-menu-content', HeaderMenuContent);
}
/**
 * Find the closest submenu.
 * @param {Element | null | undefined} element
 * @returns {HTMLElement | null}
 */
function findSubmenu(element) {
    if (!element) return null;
    // Cerca tra i discendenti
    let submenu = element.querySelector('[ref="submenu[]"]');
    if (submenu instanceof HTMLElement) return submenu;
    // Altrimenti cerca tra gli ascendenti
    submenu = element.closest('[ref="submenu[]"]');
    return submenu instanceof HTMLElement ? submenu : null;
}
